import { compareDates } from './dates.js';
export function groupToday(tasks, today) {
    const groups = { overdue: [], carriedOver: [], today: [], done: [] };
    for (const task of tasks) {
        if (task.status === 'dropped')
            continue;
        if (task.status === 'done') {
            if (task.scheduledFor === today)
                groups.done.push(task);
            continue;
        }
        // Задача может быть и просроченной по сроку, и оставшейся со вчера.
        // Показываем один раз: истёкший срок важнее.
        if (task.dueDate && compareDates(task.dueDate, today) < 0) {
            groups.overdue.push(task);
        }
        else if (task.scheduledFor && compareDates(task.scheduledFor, today) < 0) {
            groups.carriedOver.push(task);
        }
        else if (task.scheduledFor === today) {
            groups.today.push(task);
        }
    }
    for (const key of Object.keys(groups)) {
        groups[key].sort((a, b) => a.sortOrder - b.sortOrder || (a.id < b.id ? -1 : 1));
    }
    return groups;
}
/**
 * Приложение показывает нагрузку и мягко предупреждает о перегрузке,
 * но никогда не запрещает (docs/PRODUCT.md, принципы интерфейса).
 */
export function dayLoad(tasks, limitMinutes) {
    let plannedMinutes = 0;
    let hasUnestimated = false;
    for (const task of tasks) {
        if (task.status !== 'todo')
            continue;
        if (task.estimateMinutes == null)
            hasUnestimated = true;
        else
            plannedMinutes += task.estimateMinutes;
    }
    return {
        plannedMinutes,
        limitMinutes,
        hasUnestimated,
        overLimit: limitMinutes > 0 && plannedMinutes > limitMinutes,
    };
}
export function isInbox(task) {
    return task.status === 'todo' && !task.scheduledFor && !task.projectId;
}
//# sourceMappingURL=day.js.map